import { useAuthStore } from "@domains/auth/utils";
import { env } from "..";
import { useRecoilValue } from "recoil";
import { roleState } from "@common/state/roleState";

export const useCreateRequest = () => {
  const authState = useAuthStore.getState();
  const role = useRecoilValue(roleState);

  const requestOptions = {
    headers: {
      "hypercard-authorization": env.hypercardAuthorization,
      "x-view-as-role": role?.toString(),
      Authorization: "Bearer " + authState?.accessToken,
    },
  };

  const createRequest = (path: string, method: string, body?: any) => {
    return fetch(env.apiUrl + "/" + path, {
      ...requestOptions,
      method,
      body,
    });
  };

  return {
    createRequest,
  };
};
